import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategoryPreview from './components/CategoryPreview';
import ArticleHighlight from './components/ArticleHighlight';
import TestimonialSection from './components/TestimonialSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <PageMeta
      title="久久久久 - 持久稳定体验官方落地页 | 品质保障 长效服务 稳定性能 耐久方案"
      description="久久久久，专注持久稳定的极致体验。无论是品质保障、长效服务还是耐久性能，久久久久为您提供经久不衰的可靠选择，让每一次使用都持续满足您的需求。"
      keywords="久久久久,久久久久持久体验,久久久久长效保障,久久久久稳定性能,久久久久品质服务,久久久久耐久解决方案"
      ogImage="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20geometric%20design%20with%20flowing%20lines%2C%20minimalist%20modern%20aesthetic%2C%20professional%20brand%20identity%2C%20clean%20design%2C%20warm%20earthy%20tones&width=1200&height=630&seq=og-home&orientation=landscape"
    >
      <SchemaOrg type="Organization" data={{
        name: '久久久久',
        url: 'https://jiujiujiujiu.com',
        description: '久久久久，专注持久稳定的极致体验。品质保障、长效服务、稳定性能、耐久方案。',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-9999',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: '上海',
          addressRegion: '上海',
          addressCountry: 'CN',
        },
      }} />

      <SchemaOrg type="WebSite" data={{
        name: '久久久久',
        url: 'https://jiujiujiujiu.com',
        description: '久久久久 - 持久稳定体验官方落地页',
        inLanguage: 'zh-CN',
      }} />

      <SchemaOrg type="WebPage" data={{
        name: '久久久久首页',
        url: 'https://jiujiujiujiu.com',
        description: '久久久久，专注持久稳定的极致体验。品质保障、长效服务、稳定性能、耐久方案。',
        isPartOf: { '@type': 'WebSite', name: '久久久久', url: 'https://jiujiujiujiu.com' },
      }} />

      <SchemaOrg type="FAQPage" data={{
        mainEntity: [
          {
            '@type': 'Question',
            name: '久久久久的产品保修期是多久？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '久久久久所有产品均享受远超行业平均水平的保修服务。标准保修期为3年，部分高端产品享受5年超长保修。',
            },
          },
          {
            '@type': 'Question',
            name: '久久久久的售后服务如何响应？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '久久久久建立了行业领先的售后服务响应体系。工作时间内，所有售后咨询承诺2小时内给出初步响应。',
            },
          },
          {
            '@type': 'Question',
            name: '久久久久的品质管控包含哪些环节？',
            acceptedAnswer: {
              '@type': 'Answer',
              text: '久久久久独创的九重品质管控体系覆盖产品全生命周期：源头严选、进厂检测、过程监控、中期抽检、成品全检、老化测试、包装验证、物流追踪以及售后反馈闭环。',
            },
          },
        ],
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeatureSection />
          <CategoryPreview />
          <ArticleHighlight />
          <TestimonialSection />
          <FAQSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </PageMeta>
  );
}